import styled from 'styled-components';

export const TopMenuSeparator = styled.hr`
	margin-left: 0;
	margin-right: 0;
	color: ${({ theme }) => theme.colors.textSubtle || 'grey'};
	height: ${({ theme }) => theme.typography.size.xl};
`;
